import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { ActingForType } from '@models/matter';
import { TestHooks } from './acting-for-dropdown.hooks';

@Component({
	selector: 'app-acting-for-dropdown',
	templateUrl: './acting-for-dropdown.component.html',
	standalone: false,
})
export class ActingForDropdownComponent implements ControlValueAccessor {
	testHooks = TestHooks;
	public actingForTypes = ActingForType;

	@Input() submitted = false;
	@Input() label: string;
	@Input() placeholder: string;
	@Input() required = false;

	constructor(@Optional() @Self() public ngControl: NgControl) {
		if (this.ngControl !== null) {
			// Setting the value accessor directly (instead of using the providers) to avoid running into a circular import.
			this.ngControl.valueAccessor = this;
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	_onChange = (_value) => {};
	_onTouched = () => {};
	_disabled: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	_value: any;

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this._onChange(val);
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	writeValue(obj: any): void {
		this._value = obj;
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	registerOnChange(onChange: any): void {
		this._onChange = onChange;
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	registerOnTouched(onTouched: any): void {
		this._onTouched = onTouched;
	}

	setDisabledState?(isDisabled: boolean): void {
		this._disabled = isDisabled;
	}

	markAsTouched() {
		this._onTouched();
	}

	get hasErrors(): boolean {
		return (
			this.ngControl?.errors &&
			Object.keys(this.ngControl?.errors)?.length > 0 &&
			this.submitted
		);
	}
}
